import { Injectable } from '@angular/core';

//* Environments

//* Interfaces

//* Services
import { AuthService as AuthBaseService } from '../../../services/auth.service';
import { Login } from '../interfaces/auth.interfaces';

@Injectable({ providedIn: 'root' })
export class AuthService  {
	//#region --------------------------------- Variables ---------------------------------
	//#endregion

	//#region --------------------------------- Hooks ---------------------------------

	constructor(private auth: AuthBaseService) {}

	//#endregion

	//#region --------------------------------- Methods ---------------------------------
	login(data: Login){
		return this.auth.login(data); 
	}

	resetPassword(email: string){
		return this.auth.resetPassword(email);
	}

	checkPasswordToken(token: string){
		return this.auth.checkPasswordResetToken(token);
	}

	changePassword(token: string, password: string){
		return this.auth.changePassword(token, password);
	}
	//#endregion
}
